import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import UserProvider from './context/UserProvider';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import SignIn from "./pages/signIn";
import Home from "./pages/home";
import AdminImportUsers from "./pages/adminImportUsers";
import SetPassword from "./pages/setPassword";
import Waterpipes from "./pages/waterpipes";
import ElectricalAppliances from "./pages/electricalAppliances"
import Heating from "./pages/heating"
import FurnitureArrangement from "./pages/furnitureArrangement"
import Furniture from "./pages/furniture"
import UserProfile from "./pages/userProfile";
import AdminImportHousingCompanies from "./pages/adminImportHousingCompanies"
import AdminImportFloorPlans from "./pages/adminImportFloorPlan";
import AdminImportProducts from "./pages/adminImportProducts";
import Cart from "./pages/cart";
import ProductPage from "./pages/productPage";
import DelegateHistory from "./pages/history";
import AdminImportOptions from "./pages/adminImportOptions";
import AdminOptionDependencies from "./pages/adminOptionDependencies";
import AdminImportStaircases from "./pages/adminImportStaircases";
import CompanyAndStaircase from "./pages/companyAndStaircase";
import { Unauthorized } from './pages/unauthorized';

function App() {
  return (
    <UserProvider>
      <Router>
        <Routes>
            <Route path="/signin" element={<SignIn />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="/set-password" element={<SetPassword />} />
            
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Home />} />
            <Route path="/taloyhtio-ja-rapputyyppi" element={<CompanyAndStaircase />} />
            <Route path="/waterpipes" element={<Waterpipes />} />
            <Route path="/electrical-appliances" element={<ElectricalAppliances />} />
            <Route path="/heating" element={<Heating />} />
            <Route path="/furniture-arrangement" element={<FurnitureArrangement />} />
            <Route path="/furniture" element={<Furniture />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/profile" element={<UserProfile />} />
            <Route path="/product/:id" element={<ProductPage />} />
          </Route>
          
          <Route element={<AdminRoute />}>
            <Route path="/admin/import-users" element={<AdminImportUsers />} />
            <Route path="/admin/housing-company/import-options" element={<AdminImportOptions />} />
            <Route path="/admin/housing-company/option-dependencies" element={<AdminOptionDependencies />} />
            <Route path="/admin/housing-company/import-members" element={<AdminImportHousingCompanies />} />
            <Route path="/admin/housing-company/import-floorplans" element={<AdminImportFloorPlans />} />
            <Route path="/admin/housing-company/import-products" element={<AdminImportProducts />} />
            <Route path="/admin/housing-company/import-staircases" element={<AdminImportStaircases />} />
            <Route path="/admin/delegate-history" element={<DelegateHistory />} />
          </Route>
        </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;
